import React, { useEffect } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
//import AdbIcon from '@mui/icons-material/Adb';
import  LoadingButton  from '@mui/material/Button'
import { useNavigate } from 'react-router-dom';
import { showDeleteAccount, setDeleteTriggered } from "../../features/dialogSlice";
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { Backdrop, Fade, Modal } from '@mui/material';
import { useDeleteUserDataMutation } from '../../features/profilesSlice';
//import { useDeleteUserSurveysMutation } from '../../features/surveysSlice';

import TextField from '@mui/material/TextField';
import { useAuthProfile } from '../../app/hooks';
import { CircularProgressCentered } from '../../app/components/sharedcomponents';
import { setPublicPinClicked } from '../../features/dataProcessingSlice';
import { showCareCenters, showWarriors } from '../../features/filterSlice';
import { chatApi } from '../../features/ChatSlice';
import { useAuth } from "react-oidc-context";
import { SignoutResponse, User, UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts';
import { baseName } from '../..';
import { CUSTOM_METHOD, HOSTED_UI_REDIRECT } from '../../app/auth/utils';
import { skipToken } from '@reduxjs/toolkit/query';

declare global {
    interface Window {
        FB: {
            logout(callback: (response: any) => void): void;
            // Add other FB methods you need here
        };
    }
}
const style = {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    width: '400px',
    height: '400px',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    //width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
};
interface DeleteProfileProps {
    //showDeleteAccountState: boolean
    //handleSignOut: () => Promise<void>
}

// export const signOutDeleteUserFunc: ( isFederated: boolean , postSignOutFunction: ( ) => void ) => any = async (isFederated, postSignOutFunction) => {
//     if (!isFederated) {
//         console.log(`Deleting non federated user`)
//         await deleteUser();
//     }
//     const response = await signOut();
//     postSignOutFunction()//dispatch(chatApi.util.invalidateTags(['Ready']))
//     console.log("signOut:", response)
//     if (!isFederated) {
//         window.location.replace('/map');
//         //window.location.assign('/'); // Navigate to '/'
//         window.location.reload(); 
//     }
//     return response
// }

export const ConfirmDeleteProfile: React.FC<DeleteProfileProps> = ({ }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const [errorVisible, setErrorVisible] = React.useState('hidden');


    const [deleteLoading, setDeleteLoading] = React.useState(false);
    const showDeleteAccountState = useSelector((state: any) => state.dialog.showDeleteAccount);
    // fixedCacheKey → the mutation state (isLoading/isSuccess/isError) + AuthBootstrap's isDelteProfileStatus survive
    // the auth-churn REMOUNT, instead of resetting to uninitialized. Cleared on cancel-close (see handleClose).
    const [DeleteUserData, { isLoading: isLoadingDeleteProfile, isSuccess: isSuccessDeleteProfile, isError: isErrorDeleteProfile, error: errorDeleteProfile, reset }] = useDeleteUserDataMutation({ fixedCacheKey: 'deleteUserData' })
    const { authStatus,  profile, authUser, isLoading, isSuccess, isError, error, customAuth, authMethod, sub, clearLocalSession, deleteTriggered } = useAuthProfile()
    //const [DeleteSurvey, { isLoading: isLoadingDeleteSurvey, isSuccess: isSuccessDeleteSurvey, isError: isErrorDeleteSurvey, error: errorDeleteSurvey,  }] = useDeleteUserSurveysMutation()
    const auth = useAuth()
    async function handleDeleteSubmit(event: any) {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        const confirmation = data.get("deleteAccount");

        if (confirmation?.toString().toLowerCase() === "delete") {
            // federated-only: SMS/custom auth logs out cleanly (authStatus → 'unauthenticated'), so its confirm form
            // can't re-appear → it doesn't need the render gate. fixedCacheKey covers the mutation-state layer for both.
            if (authMethod !== CUSTOM_METHOD) dispatch(setDeleteTriggered(true))
            try {
                setErrorVisible('hidden');
                setDeleteLoading(true)
                try {                                
                    dispatch(setPublicPinClicked(false))
                    // dispatch(showCareCenters(false));
                    // dispatch(showWarriors(false))
                    console.log('deleting account data', profile.iam_id);                 
                    DeleteUserData({ id: profile.id, userName: sub ?? '' })//authUser.profile?["cognito:username"] })
                } catch (error) {
                    // add error handling here
                    console.log(error);
                }
            } catch (error) {
                console.log(error);
            }
            setDeleteLoading(false)
        } else {
            setErrorVisible('visible');
        }
    }
    const handleClose = () => {
        dispatch(showDeleteAccount(false))
        dispatch(setDeleteTriggered(false))
        reset() // fixedCacheKey persists mutation state between opens → clear it on cancel-close for a clean next open
        setErrorVisible('hidden');
    }
    console.log("useAuthProfile() isSuccess: ", isSuccess)

    useEffect(() => {
        const runClearLocalSesstion = async () => {
            await clearLocalSession();
        };
        console.log(`Deletion  ${isErrorDeleteProfile ? "ERROR" : "SUCCESS"}`)
        if (isSuccessDeleteProfile) {
            runClearLocalSesstion()
            setErrorVisible('hidden');
        }
        if (isSuccessDeleteProfile && isSuccess ) {
            setTimeout(() => {
                dispatch(showDeleteAccount(false))
              //  if( authStatus !== 'unauthenticated' && auth. ){                    
                        auth.signoutRedirect({
                        state: { baseName },
                        post_logout_redirect_uri: auth.settings?.post_logout_redirect_uri,
                        extraQueryParams: {
                            client_id: auth.settings?.client_id,//"7amp8un1r51k9p7qqj00jovh75",
                            redirect_uri: auth.settings?.post_logout_redirect_uri ?? false,//"http://localhost:4000/map/admin/out/",
                            logout_uri: auth.settings?.post_logout_redirect_uri ?? false,//"http://localhost:4000/map/admin/out/",
                            response_type: "code",
                            state_data: baseName
                        },
                    })
                // } else {
                // navigate('/');
                // }
            }, 1500)
        }
    }, [isSuccessDeleteProfile, isSuccess, authStatus])

    // A genuine delete FAILURE clears the flag so the error surfaces + the user can retry. The SUCCESS path keeps
    // the flag set → the modal stays in the stable "logging out" state through signout (then reload resets it).
    useEffect(() => {
        if (isErrorDeleteProfile) dispatch(setDeleteTriggered(false))
    }, [isErrorDeleteProfile])
    console.log("isLoadingDeleteProfile", isLoadingDeleteProfile, "isSuccess", isSuccessDeleteProfile, "isError", isErrorDeleteProfile)
    //const disableClose = deleteLoading  //&& !isSuccessDeleteProfile && !isErrorDeleteProfile
    return (
        <Modal aria-labelledby="transition-modal-title" aria-describedby="transition-modal-description"
            open={showDeleteAccountState}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: { timeout: 500, },
            }} >
            <Fade in={showDeleteAccountState}>
                <Box sx={{
                    position: 'absolute',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: (isErrorDeleteProfile || isSuccessDeleteProfile || isError) ? 'space-between' : null,
                    alignItems: 'flex-start',
                    width: '400px',
                    height: '400px',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    //width: 400,
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                }}>
                    {deleteTriggered ? (
                        // STABLE delete-in-progress view. The persistent deleteTriggered flag makes this immune to the
                        // auth-churn REMOUNTS that would otherwise reset the mutation state and re-show the (empty)
                        // confirm form → the accidental second delete. Shows only "Deleting…" / "Deleted, logging out…".
                        <Box sx={{ height: '100%', width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                            <CircularProgressCentered />
                            <Typography variant="h6" component="h2" sx={{ textAlign: 'center', mt: 2, px: 2 }}>
                                {isSuccessDeleteProfile
                                    ? 'Account and data has been deleted. You will now be logged out.'
                                    : 'Deleting your account data…'}
                            </Typography>
                        </Box>
                    ) : (<>
                    <Box sx={{ height: '80%', width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', }}>
                        {(isLoading || isLoadingDeleteProfile) && <CircularProgressCentered />}
                        <Typography variant="h6" component="h2">
                            {(isError || isErrorDeleteProfile) && <>Error Occurred</>}
                            {isLoadingDeleteProfile && 'Deleting your account data...'}
                            {isSuccessDeleteProfile && ' Account and data has been deleted.  You will now be logged out.'}
                        </Typography>


                    </Box>
                    {(authStatus === 'authenticated' && !isLoadingDeleteProfile && !isSuccessDeleteProfile && !isErrorDeleteProfile) && <>
                        <Typography id="transition-modal-title" variant="h6" component="h2">
                            Confirm Account Deletion
                        </Typography>
                        <Typography sx={{ mt: 2 }}>
                            Type "delete" in the box and click confirm to complete account deletion.
                        </Typography>
                        <br></br>
                        <Box component="form" onSubmit={handleDeleteSubmit} noValidate sx={{ mt: 1 }}>
                            <TextField name="deleteAccount" id="deleteAccount" label='type "delete" in box' variant="outlined" />
                            <br></br>
                            <Typography variant="caption" sx={{ visibility: errorVisible }} color='error'                            >
                                Type "delete" in the box to confirm account deletion
                            </Typography>
                            <LoadingButton loading={deleteLoading || isLoadingDeleteProfile} type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2, bcolor: '#666eff' }} disabled={!isSuccess}                            >
                                Delete account
                            </LoadingButton>

                        </Box>
                        <Button disabled={isLoadingDeleteProfile} onClick={handleClose}>Close</Button>

                    </>}

                    {(authStatus === 'unauthenticated' && !isSuccessDeleteProfile) && <>
                        <Typography variant="h5" sx={{}}                    >
                            Please login in order to delete your account data
                        </Typography>
                        <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2, bgcolor: '#666eff' }} onClick={() => navigate("/SignInToDeleteProfile")}                         >
                            LOGIN
                        </Button>
                    </>
                    }
                    </>)}
                </Box>
            </Fade>
        </Modal >
    )
}
{
/* <Typography variant="h6" component="h2">
Account data Has been deleted.
</Typography> */}
